import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TableActionButton } from "src/app/modules/competition/enums/enums";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";
import { JobsSortBy, sortDirections } from "../../../modules/jobs/enums/enums";
import { ConfirmModalService } from "../../confirm-modal/confirm-modal.service";
@Component({
  selector: "new-list-table",
  templateUrl: "./new-list-table.component.html",
  styleUrls: ["./new-list-table.component.scss"],
})
export class NewListTableComponent implements OnInit, OnDestroy {
  translationModulesEnum = TranslationModuleEnum;

  private endSub$ = new Subject();

  lang: string = this.translate.currentLang;
  @Output() action = new EventEmitter<{ actionType: string; row: any }>();
  public sortedCol: any = null;
  public sortDirection: sortDirections = sortDirections.Asc;
  @Input() sortBy;
  @Input() public set SortedCol(val: JobsSortBy | null) {
    this.sortedCol = val;
  }
  @Input() public set SortDirection(val: sortDirections | null) {
    this.sortDirection = val;
  }
  @Input() list = [];
  @Input() columns = [];
  @Input() link: string;

  @Input() totalItems: number;
  @Input() paginationModel: any = {
    pageIndex: 1,
    pageSize: 10,
  };

  @Input() autoHidePagination = false;

  @Output() sortFilter = new EventEmitter();
  @Output() onPaginateEvent = new EventEmitter();
  @Input() modEnum: string;
  @Output() selectedRowsChange = new EventEmitter<any[]>();
  @Input() selectedRows: any[] = [];
  @Input() showCheckBoxes: boolean = false;
  @Input() hasPagination: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedRows"] && changes["selectedRows"].currentValue) {
      console.log("changing");

      const newSelectedRows = changes["selectedRows"].currentValue;
      if (Array.isArray(newSelectedRows) && newSelectedRows.length === 0) {
        this.resetSelectedRows();
      }
    }
  }
  onRowSelect(row) {
    if (row.selected) {
      this.selectedRows.push(row);
    } else {
      const index = this.selectedRows.findIndex(r => r.id === row.id);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      }
    }
    this.selectedRowsChange.emit(this.selectedRows);
  }
  resetSelectedRows() {
    this.selectedRows = [];
    this.list.forEach(item => {
      item.selected = false;
    });
    this.selectedRowsChange.emit(this.selectedRows);
  }
  isAllSelected() {
    return this.list.every(item => item.selected);
  }
  toggleAllRows(event) {
    const isChecked = event.target.checked;
    this.list.forEach(item => {
      item.selected = isChecked;
      if (isChecked) {
        if (!this.selectedRows.includes(item)) {
          this.selectedRows.push(item);
        }
      } else {
        this.selectedRows = [];
      }
    });
    this.selectedRowsChange.emit(this.selectedRows);
  }

  constructor(public translate: TranslateService) {}

  ngOnInit(): void {
    // handles language change event
    this.handleLangChange();
    console.log(this.list);
    console.log("translate lang", this.translate.store.currentLang);
  }
  ngOnDestroy() {
    this.endSub$.next(null);
    this.endSub$.complete();
  }
  // if there is a table contains action buttons this functino tells parent component
  // which action to take dynamically
  handleAction(actionType: string, row: any): void {
    this.action.emit({ actionType, row });
  }
  // handles language change event
  handleLangChange() {
    this.translate.onLangChange.pipe(takeUntil(this.endSub$)).subscribe(() => {
      //debugger;
      this.lang = this.translate.store.currentLang;
    });
  }

  // emit a pagination event to the parent component
  onPaginate(e) {
    this.onPaginateEvent.emit(e);
  }

  // sort items by column
  sort(col: JobsSortBy) {
    if (this.sortedCol === col) {
      if (this.sortDirection === sortDirections.Asc) {
        this.sortDirection = sortDirections.Desc;
      } else {
        this.sortDirection = sortDirections.Asc;
      }
    } else {
      this.sortDirection = sortDirections.Asc;
    }

    this.sortedCol = col;
    this.sortFilter.emit({
      sortDirection: this.sortDirection,
      sortBy: this.sortedCol,
    });
  }

  public get ascMode(): boolean {
    return this.sortDirection === sortDirections.Asc;
  }

  public get descMode(): boolean {
    return this.sortDirection === sortDirections.Desc;
  }
  shouldShowButton(button: TableActionButton, row: any): boolean {
    if (!button.permissionCheck) {
      return true;
    }
    return (
      (row.actions && row.actions[button.permissionCheck] === true) ||
      row[button.permissionCheck] === true
    );
  }

  toggleDetails(item: any) {
    item.showDetails = !item.showDetails;
  }

  // new nz table content
  expandSet = new Set<number>();

  onExpandChange(id: number, expanded: boolean): void {
    if (expanded) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }




  onSortBy(key: string) {
    if (this.sortedCol === key) {
      // If the same column is clicked, toggle the sorting direction
      this.sortDirection = this.sortDirection === 0 ? 1 : 0;
    } else {
      // If a new column is clicked or no sorting is applied yet (sortedCol is null),
      // set the sorting direction to ascending (0) by default
      this.sortedCol = key;
      this.sortDirection = 0;
    }

    // Emit the new sort key and direction
    this.sortFilter.emit({
      sortBy: this.sortedCol,
      sortDirection: this.sortDirection
    });
  }

}
